import { render, staticRenderFns } from "./AccountBalances.vue?vue&type=template&id=26d61d4c&"
import script from "./AccountBalances.vue?vue&type=script&lang=js&"
export * from "./AccountBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports